import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChildren } from '@angular/core';
import { ListViewComponent } from 'components/layout/list-view/list-view.component';
import { Skeletons } from 'components/shared/skeleton/skeletons';
import { AccountingPlansLedgerPostsAmounts } from 'models/AccountingPlansLedgerPostsAmounts';
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { SettlementModel } from 'models/generated/Entities.GormCrm.Settlement';
import { SettlementProductPlanModel } from 'models/generated/Entities.GormCrm.SettlementProductPlan';
import { ListView } from 'modules/list-view';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { ProductNamePipe } from 'pipes/product-name.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { AccountingService } from 'services/accounting.service';

@Component({
	selector: 'settlement-product-plans',
	templateUrl: './settlement-product-plans.component.html',
	imports: [Skeletons, NgTemplateOutlet, ListView, CurrencyPipe, TranslatePipe, CustomDatePipe, ProductNamePipe]
})
export class SettlementProductPlansComponent {

	@ViewChildren(ListViewComponent) listViews!: ListViewComponent[];

	@Output() activeSettlementProductPlanChange = new EventEmitter<SettlementProductPlanModel>();
	@Input() activeSettlementProductPlan?: SettlementProductPlanModel;
	@Input() plansAmount!: AccountingPlansLedgerPostsAmounts;
	@Input() selectable = true;
	@Input() clickable = true;
	@Input() parent?: string;
	@Input() showIncludeVat = false;

	rootSettlementProductPlans?: SettlementProductPlanModel[];

	private _settlement?: SettlementModel;
	@Input() set settlement(settlement: SettlementModel | undefined) {
		this._settlement = settlement;
		this.rootSettlementProductPlans = undefined;
		if (!settlement) return;

		let rootSettlementProductPlans = settlement.settlementProductPlans.filter(spp => !spp.productPlan?.parent);
		settlement.settlementProductPlans.filter(spp => spp.productPlan?.parent).forEach(spp => {
			let parentInSettlementPlans = settlement.settlementProductPlans.find(p => p.productPlan?.id == spp.productPlan?.parent?.id);
			if (parentInSettlementPlans && (!parentInSettlementPlans.childs || !parentInSettlementPlans.childs.some((c: SettlementProductPlanModel) => c.productPlanId == spp.productPlanId)))
				parentInSettlementPlans.childs = parentInSettlementPlans.childs ? parentInSettlementPlans.childs.concat([spp]) : [spp];
			else if (!parentInSettlementPlans) {
				rootSettlementProductPlans.push(spp);
			}
		});
		this.rootSettlementProductPlans = rootSettlementProductPlans;
	}
	get settlement() { return this._settlement; }

	openAmount(accountingPlan: AccountingPlanModel) {
		return this.plansAmount.openAmount(accountingPlan.id!);
	}

	addVat(amount: number) {
		return AccountingService.addVat(amount);
	}

	selectPlan(plan: SettlementProductPlanModel) {
		this.activeSettlementProductPlan = plan;
		this.activeSettlementProductPlanChange.emit(plan);
	}
}
